import axios from "axios";
import { ensureArray } from "../utils/validateResponseApi";
import { useDataAuth } from "./useDataAuth";
import { isNotEmptyObject, safeParseJSONNotRef, safeStringifyJSON } from "../utils/jsonValidator";

const interpolatePlaceholders = (item, values) => {
    if (typeof item === 'string') {
        return item.replace(/\{(\w+)\}/g, (match, key) => {
            const val = values?.[key];
            if (val == null || val === `{${key}}` || typeof val === 'object') return match;
            return String(val);
        });
    }
    if (Array.isArray(item)) return item.map((entry) => interpolatePlaceholders(entry, values));
    if (item && typeof item === 'object') {
        const copy = {};
        for (const key in item) copy[key] = interpolatePlaceholders(item[key], values);
        return copy;
    }
    return item;
};

export function useApiTrigger() {
    const [{ userSession }] = useDataAuth();

    const getDataRequest = async (config, variables) => {
        if (!config?.trigger?.length) return [];

        const apiConfig = config.trigger[0];
        try {
            let bodyData = safeParseJSONNotRef(apiConfig.bodyData);
            if (isNotEmptyObject(variables)) {
                let varb = safeParseJSONNotRef(bodyData?.variables);
                for (let key in variables) {
                    if (variables[key] != null && typeof variables[key] !== 'object') {
                        varb[key] = variables[key];
                    }
                }
                bodyData.variables = safeStringifyJSON(varb, 0);
                bodyData = interpolatePlaceholders(bodyData, variables);
            }
            const response = await axios({
                method: apiConfig.method,
                url: apiConfig.url,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userSession?.token}`
                },
                data: bodyData,
            });
            return ensureArray(response.data);
        } catch (err) {
            return [];
        }
    };

    return { getDataRequest };
}
